module.exports = __webpack_public_path__ + "static/media/img-varanda-sanpaolo.926c57fa.jpg";